module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_platelets_8-9fbaae1e6cb895743d5ccec78166ef83.jpg";